





































































































































































































import { Component, Vue } from "vue-property-decorator";
import FmiFooter from "@/components/FMI/FmiFooter.vue";
import svgTwitter from "@/components/svg/svg-twitter.vue";
import svgLinkedin from "@/components/svg/svg-linkedin.vue";
import svgInstagram from "@/components/svg/svg-instagram.vue";
import svgFeedBurner from "@/components/svg/svg-feedburner.vue";
import svgYoutube from "@/components/svg/svg-youtube.vue";
import svgFacebook from "@/components/svg/svg-facebook.vue";

@Component({
    components: {
        "fmi-footer": FmiFooter,
        "svg-twitter": svgTwitter,
        "svg-likedin": svgLinkedin,
        "svg-instagram": svgInstagram,
        "svg-feedburner": svgFeedBurner,
        "svg-youtube": svgYoutube,
        "svg-facebook": svgFacebook,
    },
})
export default class SiteFooter extends Vue {
    publicPath = process.env.BASE_URL;

    get footerContent() {
        return this.$store.getters.getPageOptions("footer");
    }

    get LayoutOptions(): boolean {
        return this.$store.getters.layoutOptions;
    }

    get socialMediaAccount() {
        return this.$store.getters.socialMediaAccount;
    }

    get footerBG(): string {
        return (
            this.publicPath +
            "footer-images/" +
            this.$store.getters.layoutImages.footer
        );
    }

    get footerLogo(): string {
        return this.publicPath + "logos/" + this.$store.getters.footerLogo;
    }

    logout() {
        this.$store.dispatch("logout");
    }
}
